import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { cacheable, clearCache, headers, headersBlob } from '../util/rxjs-functions';
import { bObservableUsuario } from '../util/observable-util';

@Injectable()
export class AutenticacaoService {
    constructor(public http: Http, private bObservable: bObservableUsuario) { }

    private api: string = environment.apiEndpoint
    private apiAcessos: string = environment.acessoLink
    private resourceUrl: string = `${this.api}/api/Autenticar`
    private resourceUrlAcessos: string = this.apiAcessos

    // public obterPermissoesUsuario2(): Observable<any> {
    //     return this.http.get(`${this.resourceUrl}/permissao`, headers()).map(res => <any>res.json())
    // }

    private handleAuthError(erro: any): Observable<any> {
        if (erro.status === 403) {
            localStorage.removeItem("token");
            window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
            return Observable.of(false);
        }
        return Observable.throw(erro);
    }

    public obterPermissoesUsuario = (refresh: boolean = true) => cacheable(
        () => this.http.get(`${this.resourceUrl}/permissao`, headers()).map(res => {
            this.bObservable.setValue({ obj: res.json() });
            return res.json();
        })
        .catch(this.handleAuthError),
        localStorage.getItem('token'),
        refresh
    );

    public obterSistemas(id_sistema: number): Observable<any> {
        return this.http.get(`${this.resourceUrlAcessos}/sistema/${id_sistema}`, headers()).map(res => <any>res.json())
    }
}


// WEBPACK FOOTER //
// ./src/app/service/autenticacao.service.ts